import styles from './VerticalDivider.module.scss';

export const VerticalDivider = () => {
  return (
    <span className={styles.root}>
      <span className={styles.divider} />
    </span>
  );
};
